import { useState } from "react";

type Item = {
  bico: number | string;
  acima?: number;
  abaixo?: number;
  dma?: number;
  violacao?: boolean;
  drift?: boolean;
  score?: number;
  media?: number;
  ideal?: { i: number; f: number };
  faixa?: { min: number; max: number };
  operadores?: string[];
};

type ActionCardProps = {
  item: Item;
  operadores?: string[];
  defaultOwner?: string;
};

function badge(color: "red" | "amber" | "green" | "blue" | "slate", text: string) {
  const map: Record<string, string> = {
    red: "bg-red-100 text-red-700",
    amber: "bg-amber-100 text-amber-700",
    green: "bg-green-100 text-green-700",
    blue: "bg-blue-100 text-blue-700",
    slate: "bg-slate-100 text-slate-700",
  };
  return <span className={`px-2 py-0.5 rounded text-xs ${map[color] || map.slate}`}>{text}</span>;
}

function suggestActions(item: Item) {
  const acts: string[] = [];
  const acima = Number(item.acima || 0);
  const abaixo = Number(item.abaixo || 0);
  const dma = Number(item.dma || 0);
  const viol = !!item.violacao;
  const drift = !!item.drift;

  if (viol) {
    acts.push("Bloquear/segregar lote para inspeção imediata");
    acts.push("Recalibrar célula/load cell e verificar bicos de enchimento");
    acts.push("Executar verificação metrológica (peso padrão) e registrar evidências");
  }
  if (!viol && drift) {
    acts.push("Ajustar setpoint para o centro do ideal");
    acts.push("Revisar temperatura/viscosidade do produto no envase");
  }
  if (acima > 3) {
    acts.push("Checar tempo de enchimento e válvulas (excesso de dosagem)");
  }
  if (abaixo > 3) {
    acts.push("Checar restrições de fluxo/pressão (subdosagem)");
  }
  if (dma > 0.4) {
    acts.push("Rodar teste de repetibilidade e estabilidade por 10 amostras");
  }
  if (acts.length === 0) {
    acts.push("Monitorar por 1 turno e reavaliar tendência");
  }
  return acts;
}

export default function ActionCard({ item, operadores = [], defaultOwner = "" }: ActionCardProps) {
  const [owner, setOwner] = useState(defaultOwner || operadores[0] || "");
  const [due, setDue] = useState("");
  const [done, setDone] = useState(false);
  const [notes, setNotes] = useState("");

  const actions = suggestActions(item);

  const statusBadge = done
    ? badge("green", "Concluída")
    : item.violacao
    ? badge("red", "Crítica")
    : item.drift
    ? badge("amber", "Atenção")
    : badge("blue", "Oportunidade");

  return (
    <div className="bg-white rounded-xl p-4 card-shadow">
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-semibold">
            Bico {String(item.bico).padStart(2, "0")} {statusBadge}
          </div>
          <div className="text-xs text-slate-500 mt-0.5">
            Score {Number(item.score).toFixed(2)} · Média {Number(item.media).toFixed(2)}g · DMA{" "}
            {Number(item.dma ?? 0).toFixed(2)}g
          </div>
          <div className="text-xs text-slate-500">
            Ideal {Number(item.ideal?.i).toFixed(1)}–{Number(item.ideal?.f).toFixed(1)} · Faixa{" "}
            {Number(item.faixa?.min).toFixed(1)}–{Number(item.faixa?.max).toFixed(1)}
          </div>
          {item.operadores?.length ? (
            <div className="text-xs text-slate-500">Operadores: {item.operadores.join(", ")}</div>
          ) : null}
        </div>
        {/* 
        <label className="inline-flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="checkbox"
            className="accent-green-600"
            checked={done}
            onChange={(e) => setDone(e.target.checked)}
          />
          <span>Concluir</span>
        </label>
        */}
      </div>

      <ul className="list-disc pl-5 mt-3 space-y-1 text-sm">
        {actions.map((a, i) => (
          <li key={i}>{a}</li>
        ))}
      </ul>
      
      {/* 
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
        <div className="text-sm">
          <div className="text-xs text-slate-500 mb-1">Responsável</div>
          <select
            className="w-full border rounded-lg px-2 py-1.5 text-sm"
            value={owner}
            onChange={(e) => setOwner(e.target.value)}
          >
            {operadores.map((op) => (
              <option key={op} value={op}>
                {op}
              </option>
            ))}
            {!operadores.length && <option value="">—</option>}
          </select>
        </div>
        <div className="text-sm">
          <div className="text-xs text-slate-500 mb-1">Prazo</div>
          <input
            type="date"
            className="w-full border rounded-lg px-2 py-1.5 text-sm"
            value={due}
            onChange={(e) => setDue(e.target.value)}
          />
        </div>
        <div className="text-sm">
          <div className="text-xs text-slate-500 mb-1">Notas</div>
          <input
            type="text"
            placeholder="Observações rápidas…"
            className="w-full border rounded-lg px-2 py-1.5 text-sm"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
      </div>
      */}
    </div>
  );
}
